import React from 'react'
import { useTranslate } from '../src/hooks/useTranslate'
import { ProductUnit } from '../src/model/fragments'

export interface ParametersProps {
	id?: string
	palletType?: string
	weightPerSquareMeter?: number
	quantityPerPallet?: number
	squareMeterPerPallet?: number
	palletLayerSquareMeter?: number
	palletLayerQuantity?: number
	quantityPerSqm?: number
	palletWeight?: number
	unit?: string
}

interface Item {
	label: string
	value: string | number
}

export const Parameters: React.FunctionComponent<ParametersProps> = ({
	id,
	palletType,
	weightPerSquareMeter,
	squareMeterPerPallet,
	quantityPerPallet,
	palletLayerSquareMeter,
	palletLayerQuantity,
	palletWeight,
	quantityPerSqm,
	unit,
}) => {
	const translate = useTranslate()

	const items: Item[] = [
		['ID', id],
		['Rozměr palety', palletType],
		['Měrná jednotka', unit && translate(`unit-${unit}`)], // @TODO: translate
		[
			`Paleta (${unit === ProductUnit.item ? 'ks' : 'm²'})`,
			unit === ProductUnit.item ? quantityPerPallet : squareMeterPerPallet,
		],
		[
			unit === ProductUnit.item ? 'Hmotnost (kg)' : 'Hmotnost (kg/m²)',
			weightPerSquareMeter,
		],
		['Hmotnost palety (kg)', palletWeight],
		...(unit === ProductUnit.item
			? []
			: [['Kusy ve vrstvě palety', palletLayerQuantity]]),
		['Počet (ks/m²)', quantityPerSqm],
		...(unit === ProductUnit.item
			? []
			: [['Vrstva palety (m²)', palletLayerSquareMeter]]),
	]
		.filter(
			(it): it is [string, string | number] =>
				it[1] !== undefined && it[1] !== null,
		)
		.map(([label, value]) => ({ label, value }))

	return (
		<div className="parameters">
			{items.map((item, i) => (
				<div className="parameters-item" key={i}>
					<div className="parameters-item-label">{item.label}</div>
					<div className="parameters-item-value">{item.value}</div>
				</div>
			))}
		</div>
	)
}
